import { Nullable } from '@ps/utils';
import { MentionableUser } from '@ps/survey-utils';

export interface MentionableUsersState {
  readonly users: MentionableUser[];
  readonly loading: boolean;
  readonly cachedAt: Nullable<number>;
}

export const INITIAL_MENTIONABLE_USERS_STATE: MentionableUsersState = {
  users: [],
  loading: false,
  cachedAt: null,
};
